import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedOffline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 39,
	height: 39,
	viewBox: "0 0 39 39",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_11294_23873)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M31.7708 36.2833L16.8875 21.3208C15.6472 21.6111 14.4927 22.0465 13.424 22.6271C12.3552 23.2077 11.3986 23.9333 10.5542 24.8042L7.22917 21.4C8.07361 20.5556 8.98403 19.8167 9.96042 19.1833C10.9368 18.55 11.9792 17.9958 13.0875 17.5208L9.525 13.9583C8.44306 14.5125 7.43368 15.1261 6.49687 15.799C5.56007 16.4719 4.66944 17.2306 3.825 18.075L0.5 14.6708C1.34444 13.8264 2.22187 13.0677 3.13229 12.3948C4.04271 11.7219 5.0125 11.082 6.04167 10.475L2.71667 7.15002L4.93333 4.93335L34.0667 34.0667L31.7708 36.2833ZM19.5 33.75C18.3917 33.75 17.4549 33.3608 16.6896 32.5823C15.9243 31.8038 15.5417 30.8736 15.5417 29.7917C15.5417 28.6833 15.9243 27.7465 16.6896 26.9813C17.4549 26.216 18.3917 25.8333 19.5 25.8333C20.6083 25.8333 21.5451 26.216 22.3104 26.9813C23.0757 27.7465 23.4583 28.6833 23.4583 29.7917C23.4583 30.8736 23.0757 31.8038 22.3104 32.5823C21.5451 33.3608 20.6083 33.75 19.5 33.75ZM28.8417 24.3292L27.6938 23.1813L26.5458 22.0333L20.8458 16.3333C22.9833 16.5445 24.9823 17.0854 26.8427 17.9563C28.7031 18.8271 30.3458 19.975 31.7708 21.4L28.8417 24.3292ZM35.175 18.075C33.1431 16.0431 30.7878 14.4531 28.1094 13.3052C25.4309 12.1573 22.5611 11.5833 19.5 11.5833C18.9458 11.5833 18.4115 11.6031 17.8969 11.6427C17.3823 11.6823 16.8611 11.7417 16.3333 11.8208L12.2958 7.78335C13.4569 7.46668 14.6378 7.22918 15.8385 7.07085C17.0392 6.91252 18.2597 6.83335 19.5 6.83335C23.2472 6.83335 26.7437 7.53266 29.9896 8.93127C33.2354 10.3299 36.0722 12.2431 38.5 14.6708L35.175 18.075Z",
			fill: "url(#paint0_linear_11294_23873)"
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_11294_23873",
		x1: .300049,
		y1: 36.6959,
		x2: 39.6336,
		y2: 5.70579,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_11294_23873",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 38,
			height: 38,
			fill: "white",
			transform: "translate(0.5 0.5)"
		})
	})] })]
});
export default SvgExtendedOffline;
